var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-table",
    {
      attrs: {
        data: _vm.data,
        loading: _vm.isLoading,
        paginated: "",
        "backend-pagination": "",
        "current-page": _vm.pagination.page,
        "pagination-size": "is-small",
        "per-page": _vm.pagination.size,
        total: _vm.pagination.last * _vm.pagination.size,
        "aria-next-label": "Next page",
        "aria-previous-label": "Previous page",
        "aria-page-label": "Page",
        "aria-current-label": "Current page",
      },
      on: { "page-change": _vm.onPageChange },
      scopedSlots: _vm._u([
        {
          key: "empty",
          fn: function () {
            return [
              _c("div", { staticClass: "my-6 has-text-centered" }, [
                _c("section", { staticClass: "section is-mono" }, [
                  _c("span", { staticClass: "tag is-rounded is-medium" }, [
                    _c("i", { staticClass: "fas fa-info fa-fw" }),
                    _vm._v(" Sin usuarios para mostrar\n        "),
                  ]),
                ]),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("b-table-column", {
        attrs: { label: "Usuario" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (props) {
              return [
                _c(
                  "span",
                  [
                    _c("b-icon", { attrs: { pack: "fas", icon: "user" } }),
                    _vm._v(
                      "\n      " +
                        _vm._s(props.row.nombre + " " + props.row.apellido) +
                        "\n    "
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("b-table-column", {
        attrs: { label: "CUIL" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (props) {
              return [
                _c("span", [
                  _vm._v("\n      " + _vm._s(props.row.cuil) + "\n    "),
                ]),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("b-table-column", {
        attrs: { label: "Estado" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (props) {
              return [
                _c(
                  "span",
                  [
                    props.row.or_activo
                      ? _c(
                          "span",
                          {
                            staticClass: "tag is-success is-rounded is-medium",
                          },
                          [_vm._v("Activo")]
                        )
                      : _c(
                          "span",
                          { staticClass: "tag is-danger is-rounded is-medium" },
                          [_vm._v("Inactivo")]
                        ),
                    _vm._v(" "),
                    _c(
                      "b-tooltip",
                      { attrs: { label: "Descargar acta de habilitación" } },
                      [
                        props.row.or_activo
                          ? _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.downloadActa(props.row)
                                  },
                                },
                              },
                              [
                                _c("b-icon", {
                                  staticClass: "centered",
                                  attrs: {
                                    pack: "fas",
                                    icon: "cloud-download-alt",
                                    size: "is-medium",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _vm.$store.getters.hasAnyRole(["lyris"])
        ? _c("b-table-column", {
            attrs: { label: "Acción" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (props) {
                    return [
                      _c(
                        "div",
                        { staticClass: "buttons" },
                        [
                          props.row.or_activo
                            ? _c(
                                "b-button",
                                {
                                  staticClass: "pl-0",
                                  attrs: { type: "is-ghost" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.disableOR(props.row.id)
                                    },
                                  },
                                },
                                [_vm._v("Deshabilitar")]
                              )
                            : _c(
                                "b-button",
                                {
                                  staticClass: "pl-0",
                                  attrs: { type: "is-ghost" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.enableOR(props.row.id)
                                    },
                                  },
                                },
                                [_vm._v("Habilitar")]
                              ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              3648878445
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }